<template>
  <div class="drawer-wrapper">
    <el-drawer :wrapperClosable="true" :title="title" :visible.sync="AddReceivingAccountFlag" size="50%"
               :before-close="handleClose" direction="rtl">

      <div class="demo-drawer__content">
        <el-form :model="addFrom" :rules="rules" ref="ruleForm">
          <el-row :gutter="35">

            <el-col :xs="24" :sm="24" :md="24" :lg="24" :xl="24" class="mb20">
              <el-form-item label="关联主体" prop="subject_id" :label-width="formLabelWidth">
                <div style="display: flex;">
                <el-select v-model="addFrom.subject_id" placeholder="请选择关联主体" clearable @change="setSubjectName" style="width: 85%;">
                  <el-option v-for="dict in subjectList" :key="dict.id" :label="dict.name"
                             :value="dict.id"/>
                </el-select>
                <img @click="AddPushSubjec"
                  style="width: 25px;height: 25px;margin-left:10px;margin-top:5px;cursor: pointer;"
                  src="@/assets/btn/xinzeng.png" alt="">
                  <img @click="AddRefreshSubjec"
                  style="width: 25px;height: 25px;margin-left:10px;margin-top:5px;cursor: pointer;"
                  src="@/assets/btn/shuaxin.png" alt="">
                </div>
              </el-form-item>
            </el-col>

            <el-col :xs="24" :sm="24" :md="24" :lg="24" :xl="24" class="mb20">
              <el-form-item label="收款公司" prop="subject_name" :label-width="formLabelWidth">
                <el-input v-model="addFrom.subject_name" placeholder="请输入收款公司" clearable style="width: 85%;"></el-input>
              </el-form-item>
            </el-col>

            <el-col :xs="24" :sm="24" :md="24" :lg="24" :xl="24" class="mb20">
              <el-form-item label="开户行" prop="bank" :label-width="formLabelWidth">
                <el-input v-model="addFrom.bank" placeholder="请输入开户行" clearable style="width: 85%;"></el-input>
              </el-form-item>
            </el-col>

            <el-col :xs="24" :sm="24" :md="24" :lg="24" :xl="24" class="mb20">
              <el-form-item label="银行账号" prop="bank_account" :label-width="formLabelWidth">
                <el-input v-model.trim="addFrom.bank_account" @input="handleInput" placeholder="请输入银行账号" clearable style="width: 85%;"></el-input>
              </el-form-item>
            </el-col>


            <el-col :xs="24" :sm="24" :md="24" :lg="24" :xl="24" class="mb20">
              <el-form-item label="状态" prop="status" :label-width="formLabelWidth" style="width: 85%;">
                <el-radio-group v-model="addFrom.status">
                  <el-radio :label="1">正常</el-radio>
                  <el-radio :label="0">禁用</el-radio>
                </el-radio-group>
              </el-form-item>
            </el-col>

          </el-row>
        </el-form>
      </div>
      <div class="demo-drawer__footer">
        <el-button @click="AddNone">取 消</el-button>
        <el-button type="primary" @click="addPush">确 定</el-button>
      </div>

    </el-drawer>
   
  </div>
</template>

<script>
import {MoneyManagementAPI} from '@/api/MoneyManagement/MoneyManagement';
import {processErrors} from "@/utils/errorHandler";
export default {
  props: ['AddReceivingAccountFlag', "editID"],
  components: {
  
  },
  data() {
    return {
      title: "新增",
      formLabelWidth: "140px",
      addFrom: {
        subject_id: "",
        subject_name: "",
        bank: "",
        bank_account: "",
        status: 1,
        id: "",
      }, rules: {
        subject_id: [
          {required: true, message: '请选择关联主体', trigger: 'change'}
        ],
        subject_name: [
          {required: true, message: '请输入收款公司', trigger: 'blur'},
        ],
        bank: [
          {required: true, message: '请输入开户行', trigger: 'blur'},
        ],
        bank_account: [
          {required: true, message: '请输入银行账号', trigger: 'blur'},
        ],
        status: [
          {required: true, message: '请选择状态', trigger: 'change'}
        ],

      },
      subjectList: {},
    };
  },
  created() {
    this.getSubjectSelect();
  },
  methods: {

    getSubjectSelect() {
      let api = MoneyManagementAPI()
      api.getSubjectSelect().then(res => {
        if (res.code == 0) {
          this.subjectList = res.data
        } else {
          processErrors(res);
        }
      })
    },

    setSubjectName(e){
      let subject_info = this.subjectList.find(item => item.id === e);
      if (subject_info) {
        this.addFrom.subject_name = subject_info.name; // 或者 subject.id，取决于您需要的值
      } else {
        this.addFrom.subject_name = ''; // 如果没有找到，清空
      }
    },

    handleClose(done) {
      this.$emit('NoneDlog');
      this.$refs['ruleForm'].resetFields();
    },

    AddNone() {
      this.addFrom = {
        name: "",
        status: "",
        subject_id: '',
        id: "",
      }
      this.title = ""
      this.$refs['ruleForm'].resetFields();
      this.$emit('NoneDlog');
    },

    addPush() {
      this.$refs['ruleForm'].validate((valid) => {
        if (valid) {
          let createText = ''
          if (this.addFrom.id == "") {
            createText = "创建成功";
          } else {
            createText = "修改成功";
          }

          let api = MoneyManagementAPI()
          api.receivingAccountAdded(this.addFrom).then(res => {
            if (res.code == 0) {
              this.$message({
                message: createText,
                type: 'success'
              });
              this.$emit('AddOk');
            } else {
              processErrors(res);
            }
          })
        } else {
          return false;
        }
      });
    },
    AddPushSubjec() {
      const baseExportUrl = new URL(window.location.href).origin;
        let url = baseExportUrl + '/#/MoneyManagement/subject';
        window.open(url);
    },
    AddRefreshSubjec(){
      this.getSubjectSelect()
    },
    handleInput(value) {
      // 去除所有空格
      this.addFrom.bank_account = value.replace(/\s+/g, '');
    }
  },

  mounted() {
    if (this.editID != "") {
      let api = MoneyManagementAPI()
      api.receivingAccountInfo(this.editID).then(res => {
        if (res.code == 0) {
          this.title = "编辑"
          this.addFrom = res.data
        } else {
          processErrors(res);
        }
      })
    }

  },
}
</script>
<style lang='scss' scoped>
.demo-drawer__content {
  height: calc(100% - 80px); /* 给内容区域设置高度,留出按钮区域 */
  overflow-y: auto; /* 添加垂直滚动条 */
  margin-top: 20px;
  overflow-x: hidden;
}

.form-wrapper {
  padding-bottom: 80px; /* 给表单内容添加底部间距,留出按钮区域 */
}

.demo-drawer__footer {
  position: absolute;
  bottom: 0;
  left: 0;
  width: 100%;
  padding: 10px;
  text-align: center;
}

.demo-drawer__footer .el-button {
  margin: 0 10px;
  width: calc(50% - 20px);
}

::v-deep .el-drawer__close-btn {
  font-size: 30px;
  font-weight: bold;
}

.avatar-uploader .el-upload {
  border: 1px dashed #d9d9d9;
  border-radius: 6px;
  cursor: pointer;
  position: relative;
  overflow: hidden;
}

.avatar-uploader .el-upload:hover {
  border-color: #409EFF;
}

.avatar-uploader-icon {
  font-size: 28px;
  color: #8c939d;
  width: 178px;
  height: 178px;
  line-height: 178px;
  text-align: center;
}

.avatar {
  width: 178px;
  height: 178px;
  display: block;
}
</style>